import get from 'lodash.get';
import getActiveEcommerceSubscription from './active-ecommerce-subscription';
import type { RootState } from '../types/store';
import type { SubscriptionType } from '../types/subscription';

function getActiveEcommerceSubscriptionType(state: RootState): SubscriptionType | null {
  const activeEcommerceSubscription = getActiveEcommerceSubscription(state);

  return get(activeEcommerceSubscription, 'type', null);
}

export default getActiveEcommerceSubscriptionType;
